import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Breadcrumb from './components/Breadcrumb';
import { recollect } from './util/apiUtils';
import AlertMessage from './AlertMessage';

/**
 * Read the accessionNo from URL params and fire off a re-collect request.
 * The user will be redirected to the new order on success or shown an error message on failure.
 */
export default function Recollection() {
	let { accessionNo } = useParams();
	const [reCollectionResponse, setReCollectionResponse] = useState();

	useEffect(() => {
		setReCollectionResponse(null);

		recollect(accessionNo)
			.then((json) => {
				setReCollectionResponse(json);
			})
			.catch((err) => {
				setReCollectionResponse({ status: 'ERROR', error: err });
			});
	}, [accessionNo]);

	if (reCollectionResponse?.status === 'SUCCESS' && reCollectionResponse?.redirectUrl) {
		return <Redirect to={reCollectionResponse?.redirectUrl} />;
	}

	return (
		<div>
			<Breadcrumb breadcrumbStep="Re-collect" singleLevel={true} />
			<div className="container space-bottom">
				<div>
					<h1>Re-collect Specimens for {accessionNo}</h1>
					{reCollectionResponse ? (
						<RecollectionError reCollectionResponse={reCollectionResponse} accessionNo={accessionNo} />
					) : (
						<>
							<div className="space-top text-center">
								<h3>Creating order</h3>
								<i className="fa fa-spinner fa-spin fa-fw " style={{ fontSize: '3em' }}></i>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
}

/**
 * Show an appropriate error message based on the reCollectionResponse's status.
 */
const RecollectionError = ({ reCollectionResponse, accessionNo }) => {
	//SUCCESS, ERROR, UNAUTHORIZED, ORDER_NOT_FOUND, AUTHENTICATION_ERROR
	const responseStatus = reCollectionResponse?.status || 'ERROR';

	let errorMessage;
	switch (responseStatus) {
		case 'UNAUTHORIZED':
			errorMessage = `You are not authorized to re-collect for order ${accessionNo}`;
			break;
		case 'ORDER_NOT_FOUND':
			errorMessage = `We were not able to locate details for order ${accessionNo}`;
			break;
		default:
			errorMessage = `An unexpected error has occurred.`;
			break;
	}
	return <AlertMessage type="danger">{errorMessage}</AlertMessage>;
};
